<div class="timeline-container">
  <div *ngFor="let timelineStep of timeLineContent" class="timeline-container_step">
    <div class="timeline-container_step-container" [class.completed-component]="timelineStep.isStepCompleted">
      <div
        class="timeline-container_step-wrapper"
        [ngClass]="{
          active_wrapper: timelineStep.isActive,
          inactive_wrapper: !timelineStep.isActive,
          completed: timelineStep.isStepCompleted
        }"
      >
        <div class="step-number-container" [class.completed-step]="timelineStep.isStepCompleted">
          <h2>{{ timelineStep.stepNumber }}</h2>
        </div>
      </div>
      <div class="timeline-title">
        <span class="step-number-heading" [ngClass]="{ strong: timelineStep.isActive }">
          {{ timelineStep.stepTitle }}
        </span>
      </div>
    </div>

    <div
      class="timeline-connector"
      [ngClass]="{
        completed_line: timelineStep.isStepCompleted,
        incompleted_line: !timelineStep.isStepCompleted
      }"
    ></div>
  </div>
</div>
